import { useMutation } from "@apollo/client";
import gql from "graphql-tag";
import mixpanel from "mixpanel-browser";
import React, { PropsWithChildren, useCallback } from "react";

import {
  MarkMarketingPromptAsReadMutation,
  MarkMarketingPromptAsReadMutationVariables,
} from "../../../../../__generated__/graphql";
import megaphone from "../../../assets/images/megaphone.svg";
import Alert from "../../design-system/Alert";
import styles from "../../design-system/Toaster/styles.module.scss";

const MARK_MARKETING_PROMPT_AS_READ = gql`
  mutation markMarketingPromptAsRead($featureId: String!) {
    markFeatureAnnouncementAsRead(feature: $featureId) {
      id
      unreadFeatureAnnouncements
    }
  }
`;

export default function ExtraMarketingPrompt({
  featureId,
  prompt,
  destination,
  children,
}: PropsWithChildren<{ featureId: string; prompt?: string; destination?: string }>) {
  const [clearPrompt] = useMutation<MarkMarketingPromptAsReadMutation, MarkMarketingPromptAsReadMutationVariables>(
    MARK_MARKETING_PROMPT_AS_READ,
    { variables: { featureId } },
  );

  const clickClose = useCallback(async () => {
    mixpanel.track("Dismissed the marketing prompt call to action", { featureId });
    await clearPrompt();
  }, [clearPrompt, featureId]);

  const clickCta = useCallback(async () => {
    mixpanel.track("Clicked the marketing prompt call to action", { featureId });
    await clearPrompt();
  }, [clearPrompt, featureId]);

  return (
    <Alert
      className={styles.toastAlert}
      onClickClose={clickClose}
      icon={<img src={megaphone} alt="" width={96} height={88} />}
      actions={
        prompt && destination
          ? [{ label: prompt, to: destination, variant: "primary", linkType: "external", onClick: clickCta }]
          : undefined
      }
    >
      {children}
    </Alert>
  );
}
